<h3 mat-dialog-title class="dialog-title">Amenities</h3>
<div mat-dialog-content>
  <mat-list>
    <mat-list-item *ngFor="let item of amenities">
      <mat-checkbox [value]="item.name" color="primary">{{item.name }}</mat-checkbox>
    </mat-list-item>
  </mat-list>
</div>
